module.exports = __webpack_public_path__ + "img/rc-bottom.84a4477c.png";